import React from 'react';
import { getStaticUrl } from '../../../../utils/img';

const Empty = () => (
  <img src={getStaticUrl('web/v1/img/member_center_list_empty.png')} />
);

export default Empty;
